<template>
	<div>
		<header class="page-title">
			<h2>About us page</h2>
			<div class="ml-auto">
				<a class="btn btn-md btn-success" @click="openModal()"><i class="fas fa-save"></i> Add New Team member</a>
			</div>
		</header>

		<div class="table-responsive">
			<h2>Our Researchers</h2>
			<table class="comments">
				<thead>
				<tr>
					<th>Order</th>
					<th>Group</th>
					<th>Group</th>
					<th>User</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(user, index) in settings.researchers">
					<td>{{ user.order }}</td>
					<td>{{ user.sub_group }}</td>
					<td>{{ user.key }}</td>
					<td v-if="users[user.value]">{{ users[user.value].name }}</td>
					<td v-if="!users[user.value]">{{ user.value }}</td>
					<td class="nowrap">
						<a @click.prevent="editUser('researchers',index)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click.prevent="deleteUser(user.id)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div class="table-responsive">
			<h2>Chairman</h2>
			<table class="comments">
				<thead>
				<tr>
					<th>Order</th>
					<th>Group</th>
					<th>Group</th>
					<th>User</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(user, index) in settings.chairman">
					<td>{{ user.order }}</td>
					<td>{{ user.sub_group }}</td>
					<td>{{ user.key }}</td>
					<td v-if="users[user.value]">{{ users[user.value].name }}</td>
					<td v-if="!users[user.value]">{{ user.value }}</td>
					<td class="nowrap">
						<a @click.prevent="editUser('chairman',index)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click.prevent="deleteUser(user.id)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div class="table-responsive">
			<h2>Development Team</h2>
			<table class="comments">
				<thead>
				<tr>
					<th>Order</th>
					<th>Group</th>
					<th>Group</th>
					<th>User</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(user, index) in settings.development">
					<td>{{ user.order }}</td>
					<td>{{ user.sub_group }}</td>
					<td>{{ user.key }}</td>
					<td v-if="users[user.value]">{{ users[user.value].name }}</td>
					<td v-if="!users[user.value]">{{ user.value }}</td>
					<td class="nowrap">
						<a @click.prevent="editUser('development',index)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click.prevent="deleteUser(user.id)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div class="table-responsive">
			<h2>Additional Team Members</h2>
			<table class="comments">
				<thead>
				<tr>
					<th>Order</th>
					<th>Group</th>
					<th>Group</th>
					<th>User</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(user, index) in settings.digital_team">
					<td>{{ user.order }}</td>
					<td>{{ user.sub_group }}</td>
					<td>{{ user.key }}</td>
					<td v-if="users[user.value]">{{ users[user.value].name }}</td>
					<td v-if="!users[user.value]">{{ user.value }}</td>
					<td class="nowrap">
						<a @click.prevent="editUser('digital_team',index)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click.prevent="deleteUser(user.id)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div class="table-responsive">
			<h2>Pr Team</h2>
			<table class="comments">
				<thead>
				<tr>
					<th>Order</th>
					<th>Group</th>
					<th>Group</th>
					<th>User</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(user, index) in settings.pr_team">
					<td>{{ user.order }}</td>
					<td>{{ user.sub_group }}</td>
					<td>{{ user.key }}</td>
					<td v-if="users[user.value]">{{ users[user.value].name }}</td>
					<td v-if="!users[user.value]">{{ user.value }}</td>
					<td class="nowrap">
						<a @click.prevent="editUser('pr_team',index)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click.prevent="deleteUser(user.id)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_settings.update')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">Add New Team member</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six">
						<label for="sub_group">Group</label>
						<select id="sub_group" v-model="newUser.sub_group" @change="setKey">
							<option v-for="sub_group in sub_groups" :value="sub_group">{{ sub_group }}</option>
						</select>
						<p class="input-error" v-if="errors.errors.sub_group">{{ errors.errors.sub_group }}</p>
					</div>
					<div class="form-group six">
						<label for="key">Sub Group</label>
						<select id="key" v-model="newUser.key" :disabled="!newUser.sub_group" @change="setOrder">
							<option v-for="key in selectedKeys" :value="key">{{ key }}</option>
						</select>
						<p class="input-error" v-if="errors.errors.key">{{ errors.errors.key }}</p>
					</div>
					<div class="form-group three">
						<label for="order">Order</label>
						<input id="order" type="text" value="" required v-model="newUser.order">
						<p class="input-error" v-if="errors.errors.order">{{ errors.errors.order }}</p>
					</div>
					<div class="form-group nine">
						<label for="value">User</label>
						<select id="value" v-model="newUser.value">
							<option v-for="user in teamList" :value="user.id">{{ user.name }}</option>
						</select>
						<p class="input-error" v-if="errors.errors.value">{{ errors.errors.value }}</p>
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close">
					<i class="fas fa-times"></i> Cancel</a>
				<a @click="addUser" v-if="!isUpdate" class="btn btn-md btn-success"><i class="fas fa-save"></i> Add Team member</a>
				<a @click="updateUser" v-if="isUpdate" class="btn btn-md btn-success"><i class="fas fa-save"></i> Update Team member</a>
			</template>
		</modal>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import modal from "../Modal/DefaultModal.vue";
import Errors from '../../Utils/Errors.js';

export default {
	name: "SettingsAboutUs",
	components: {
		modal
	},
	data() {
		return {
			settings: {},
			users: [],
			teamList: [],
			isModalVisible: false,
			userRoles: this.$currentUserRoles,
			newUser: {
				group: 'about_us',
				sub_group: null,
				key: null,
				value: null,
				order: 1,
			},
			isUpdate: false,
			sub_groups: [
				'our_team',
				'pr_team',
				'researchers',
			],
			keys: {
				our_team: ['digital_team','development','chairman'],
				pr_team: ['pr_team'],
				researchers: ['researchers'],
			},
			selectedKeys: null,

			errors: new Errors()
		}
	},
	mounted() {
		let vm = this;

		vm.getSettings();
		vm.getUsers();
	},
	methods: {
		openModal: function () {
			this.isModalVisible = true;
		},
		closeModal: function () {
			this.isModalVisible = false;
			this.newUser = {
				group: 'about_us',
				sub_group: null,
				key: null,
				value: 0,
				order: 1,
			};
			this.isUpdate = false;
		},
		getSettings: function() {
			eventBus.$emit('onLoaderStart');
			let vm = this;

			axios.get('/api/' + vm.$selectedSite.slug + '/team')
				.then(response => {
					vm.settings = response.data;
					vm.$toastr.success('About Us data loaded successfully', 'Success');
				})
				.catch(e => {
					eventBus.$emit('onLoaderFinish');
					this.$toastr.error('About Us data load failed.', 'Error');
				});
		},
		getUsers: function() {
			let vm = this;
			axios.post('/api/users/listall')
				.then(response => {
					vm.users = response.data.data.allUsers.reduce((r, o) => (r[o.id] = o, r), []);
					vm.teamList = response.data.data.allUsers;
					vm.$toastr.success('Users data loaded successfully', 'Success');
				})
				.catch(e => {
					eventBus.$emit('onLoaderFinish');
					this.$toastr.error('Users data load failed.', 'Error');
				});
		},
		addUser: function() {
			let vm = this,
				emptyErrors = true;

			vm.settings.users.forEach(function(value) {
				if (parseInt(value) === parseInt(vm.newUser.value)) {
					vm.errors.record({errors: {value: ['This user is already in this team!']}});
					emptyErrors = false;
				} // if
			});

			if (emptyErrors) {
				axios.post('/api/' + this.$selectedSite.slug + '/about-us', vm.newUser)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('Add Team member saved successfully', 'Success');
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						} else {
							this.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Add Team member save failed.', 'Error');
					});
			} // if
		},
		editUser: function(group, id) {
			let vm = this;

			vm.isUpdate = true;
			vm.newUser = vm.settings[group][id];
			vm.setKey();
			vm.isModalVisible = true;
		},
		updateUser: function() {
			let vm = this;

			axios.put('/api/' + this.$selectedSite.slug + '/about-us/' + vm.newUser.id, vm.newUser)
				.then(response => {
					if (response.data.success) {
						this.$toastr.success('Team member data updated successfully', 'Success');
						setTimeout(function () {
							window.location.reload();
						}, 1000);
					} else {
						this.$toastr.error(response.data.failed, 'Error');
					} // if
				})
				.catch(e => {
					this.errors.record(e.response.data);
					this.$toastr.error('Data save failed.', 'Error');
				});
		},
		deleteUser: function(id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to remove this user from About us page?')
				.then((dialog) => {
					axios.delete('/api/' + vm.$selectedSite.slug + '/about-us/' + id)
						.then(response => {
							vm.$toastr.success('Delete successful.');
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						})
						.catch(errors => {
							dialog.close();
							vm.$toastr.error('Delete user failed.');
						});
				})
				.catch(error => {
					vm.$toastr.error('Delete aborted.');
				});
		},
		setKey: function() {
			let vm = this;
			vm.selectedKeys = vm.keys[vm.newUser.sub_group];
		},
		setOrder: function() {
			let vm = this,
				selectedKey = vm.newUser.key;
			vm.newUser.order = Math.max.apply(null,Object.keys(vm.settings[selectedKey]))+1;
		}
	}
}
</script>

<style scoped>

</style>
